<div class="p-6">
  <h2 mat-dialog-title class="text-xl font-semibold mb-2 text-green-700">
    <mat-icon class="align-middle mr-2">check_circle</mat-icon>
    Bidding Invitation Sent
  </h2>
  <p mat-dialog-content class="text-gray-600 text-sm mb-4">
    Share the link below with the selected consultancy organizations. They can view project details and submit their bids.
  </p>

  <div class="mb-4">
    <label class="block text-sm font-medium text-gray-700 mb-2">Bidding Link</label>
    <div class="flex gap-2">
      <input
        type="text"
        [value]="biddingLink"
        readonly
        class="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-sm"
      />
      <button mat-stroked-button color="primary" (click)="copyToClipboard()">
        <mat-icon>content_copy</mat-icon>
        Copy
      </button>
    </div>
  </div>

  <div mat-dialog-actions class="flex justify-end pt-4">
    <button mat-raised-button color="primary" (click)="onClose()">
      Done
    </button>
  </div>
</div>
